import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import R1CapitalAccountView from "@/features/R1Dashboard/views/CapitalAccountView";

export default function R1CapitalAccount() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Capital Account");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <R1CapitalAccountView />
      </main>
    </R1DashboardProvider>
  );
}
